import { memo, type ReactElement, type ReactNode } from "react";
import { RegularText } from "src/components/v1";
import { cn } from "src/utilities/shadcnUtils";

export interface FinePrintProps {
  children: string | ReactElement<any> | Array<string | ReactElement<any>> | ReactNode;
  className?: string;
}

const FinePrint = ({ children, className }: FinePrintProps) => (
  <RegularText className={cn("text-xs mb-5", className)} paragraph>
    {children}
  </RegularText>
);

export default memo(FinePrint);
